import React, {useState,useEffect} from "react";
import { useNavigate } from "react-router-dom";

import TopNav from "../components/TopNav";
import axios from "axios";
import  "./CharterCreatePage.css";

const CharterCreatePage = (props) => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [newCharterData, setNewCharterData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [modalMessage, setModalMessage] = useState("");

    const funds = newCharterData?.funds !== undefined ? Number(newCharterData.funds) : null;
    const charterCost = newCharterData?.cost !== undefined ? Number(newCharterData.cost) : null;
    const hasInsufficientFunds = funds !== null && charterCost !== null && funds < charterCost;
    const formattedFunds = funds !== null ? funds.toLocaleString(undefined, { minimumFractionDigits: 0 }) : "--";
    const formattedCost = charterCost !== null ? charterCost.toLocaleString(undefined, { minimumFractionDigits: 0 }) : "--";

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("userData"));
        if (storedData) {
            console.log(storedData)
        }
        return () => {}
    }, []);

    const requestNewCharter = async (orig,dest) => {

        setLoading(true);
        setError(null);
        
        try {
            const { data } = await axios.get("/api/charters/request", {
                params: {_t: Date.now(),
                    orig: orig,
                    dest: dest,
                },
            });
            
            if (data) {
                console.log(data);
                setNewCharterData(data);
                if (data.message && data.message !== "okay") {
                    setModalType("message");
                    setModalMessage(data.message);
                    setIsModalOpen(true);
                }
            } else {
                setError("No server data");
                setNewCharterData([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError("Failed to fetch charter data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const setNewCharter = async () => {

        setLoading(true);
        setError(null);

        // Get user data from localStorage
        const storedData = JSON.parse(localStorage.getItem("userData"));
        
        if (!storedData || !storedData.iid) {
            setError("User session not found. Please log in again.");
            setLoading(false);
            setModalType("message");
            setModalMessage("User session not found. Please log in again.");
            setIsModalOpen(true);
            return;
        }

        const orig = newCharterData.orig;
        const dest = newCharterData.dest;
        const nm = newCharterData.distance;
        const ete = newCharterData.ete;
        const cost = newCharterData.cost;
        
        // Create FormData for proper POST request
        const formData = new URLSearchParams();
        formData.append('iid', storedData.iid);
        formData.append('orig', orig);
        formData.append('dest', dest);
        formData.append('nm', nm);
        formData.append('ete', ete);
        formData.append('cost', cost);
        
        try {
            const { data } = await axios.post(
                "/api/charters/create",
                formData,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
            
            if (data) {
                console.log("Charter created successfully:", data);
                
                // Show success message
                setModalType("success");
                setModalMessage("Charter Created Successfully");
                setIsModalOpen(true);
                
                // Clear the form data
                setNewCharterData(null);
                
                // Update user funds if available in response
                if (storedData.funds !== undefined && cost) {
                    storedData.funds = Number(storedData.funds) - Number(cost);
                    localStorage.setItem("userData", JSON.stringify(storedData));
                }

                // Redirect to charter manage page after 2 seconds with refresh flag
                setTimeout(() => {
                    navigate('/charter-manage', { state: { refresh: true } });
                }, 2000);
            } else {
                setError("No response from server");
                setModalType("message");
                setModalMessage("Failed to create charter. No response from server.");
                setIsModalOpen(true);
            }
        } catch (err) {
            console.error("API Error:", err);
            const errorMessage = err.response?.data?.message || "Failed to create charter. Please try again.";
            setError(errorMessage);
            setModalType("message");
            setModalMessage(errorMessage);
            setIsModalOpen(true);
        } finally {
            setLoading(false);
        }
    };

    function handleForm(e){
        e.preventDefault();
        console.log("Submit requestNewCharter");
        requestNewCharter(e.target.orig.value,e.target.dest.value);
    }

    function handleAddNewCharter(e){
        e.preventDefault();
        console.log("Submit handleAddNewCharter");
        console.log(e.target.orig.value);
        console.log(e.target.dest.value);
        console.log(e.target.nm.value);
        console.log(e.target.ete.value);
        setIsModalOpen(false);
        console.log(newCharterData)
        setNewCharter();

    }

    function handleOpenModal(){
        setModalType("confirm");
        setIsModalOpen(true);
    }

    function handleCloseModal(){
        setIsModalOpen(false);
        setModalType(null);
        setModalMessage("");
    }
    
    
    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <div className="charter-create-page">
                <header className="charter-header">
                    <button
                        type="button"
                        className="back-button"
                        onClick={() => window.history.back()}
                    >
                        ← Back
                    </button>
                    {/* <div> */}
                        {/* <p className="charter-title">Create a New Charter</p> */}
                        {/* <p className="charter-subtitle">Plan a new mission and confirm the charter details.</p> */}
                    {/* </div> */}
                </header>

                <div className="charter-content">
                    <section className="charter-card">
                        <div className="card-header">
                            {/* <span className="card-icon">🛫</span> */}
                            <div>
                                <h2>Request Charter Data</h2>
                                <p>Enter origin and destination ICAO codes to calculate distance, time, and cost.</p>
                            </div>
                        </div>
                        <form onSubmit={handleForm} className="charter-form">
                            <label>
                                Origin ICAO
                                <input type="text" name="orig" placeholder="e.g., KMEM" required />
                            </label>
                            <label>
                                Destination ICAO
                                <input type="text" name="dest" placeholder="e.g., PANC" required />
                            </label>
                            <button type="submit" className="primary-button" disabled={loading}>
                                {loading ? "Calculating..." : "Request Details"}
                            </button>
                            {error && <p className="error-text">{error}</p>}
                        </form>
                    </section>

                    <section className="charter-card">
                        <div className="card-header">
                            {/* <span className="card-icon">📋</span> */}
                            <div>
                                <h2>Charter Summary</h2>
                                
                            </div>
                        </div>
                        {!newCharterData && (
                            <div className="empty-state">
                                <p>No charter data yet. Submit a request to generate details.</p>
                            </div>
                        )}
                        {newCharterData && newCharterData.message === "okay" && (
                            <div className="summary-grid">
                                <div>
                                    <span className="summary-label">Origin Airport</span>
                                    <p>{newCharterData.geo.oapt}</p>
                                </div>
                                <div>
                                    <span className="summary-label">Destination Airport</span>
                                    <p>{newCharterData.geo.dapt}</p>
                                </div>
                                <div>
                                    <span className="summary-label">Distance</span>
                                    <p>{newCharterData.distance} NM</p>
                                </div>
                                <div>
                                    <span className="summary-label">ETE</span>
                                    <p>{newCharterData.ete} hours</p>
                                </div>
                                <div>
                                    <span className="summary-label">Cost</span>
                                    <p>{newCharterData.cost}</p>
                                </div>
                                <div>
                                    <span className="summary-label">Route</span>
                                    <p>{newCharterData.orig} → {newCharterData.dest}</p>
                                </div>
                            </div>
                        )}
                        <button
                            type="button"
                            className="secondary-button"
                            onClick={handleOpenModal}
                            disabled={!newCharterData || newCharterData.message !== "okay"}
                        >
                            Create Charter
                        </button>
                    </section>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal-overlay" role="dialog" aria-modal="true">
                    <div className="modal">
                        {/* <div className="modal-header">
                            <h3>{modalType === "message" ? "Charter Request" : "Confirm New Charter"}</h3>
                            <button type="button" className="icon-button" onClick={handleCloseModal}>
                                ✕
                            </button>
                        </div> */}
                        {modalType === "success" ? (
                            <React.Fragment>
                                <p className="modal-text">{modalMessage}</p>
                            </React.Fragment>
                        ) : modalType === "message" ? (
                            <React.Fragment>
                                <p className="modal-text">{modalMessage}</p>
                                <div className="modal-actions">
                                    <button type="button" className="primary-button" onClick={handleCloseModal}>Close</button>
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <p className="modal-text">New Charter from {newCharterData?.orig} to {newCharterData?.dest}</p>
                                <div className="modal-summary modal-finance">
                                    <div className="modal-card">
                                        <span className="summary-label">Your Funds</span>
                                        <p className="modal-amount">${formattedFunds}</p>
                                    </div>
                                    <div className="modal-card">
                                        <span className="summary-label">Charter Cost</span>
                                        <p className="modal-amount">${formattedCost}</p>
                                    </div>
                                </div>
                                {hasInsufficientFunds && (
                                    <p className="error-text">
                                        Insufficient funds. You have ${formattedFunds}, but the flight costs ${formattedCost}
                                    </p>
                                )}
                                <form onSubmit={handleAddNewCharter} className="modal-actions">
                                    <input type="hidden" name="orig" value={newCharterData?.orig || ""}/>
                                    <input type="hidden" name="dest" value={newCharterData?.dest || ""}/>
                                    <input type="hidden" name="nm" value={newCharterData?.distance || ""}/>
                                    <input type="hidden" name="ete" value={newCharterData?.ete || ""}/>
                                    <button type="button" className="ghost-button" onClick={handleCloseModal}>Cancel</button>
                                    <button type="submit" className="primary-button" disabled={hasInsufficientFunds}>Confirm Charter</button>
                                </form>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            )}
        </React.Fragment>)
}
export default CharterCreatePage;
